import React, { useEffect, useState } from "react";
import { Grid2, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../../hooks/useTranslate";
import { useStudents } from "../../../context/students";
import Breadcrumbs from "../../../components/Breadcrumbs";
import TaskCard from "../../../components/TaskCard";
import BaseDialog from "../../../components/BaseDialog";
import "./Alumni.css";

const Alumni = () => {
    const navigate = useNavigate();
    const { t } = useTranslate();
    const { alumni, onChangeActiveStudentId } = useStudents();

    const [openOverdueInvoicesModal, setOpenOverdueInvoicesModal] = useState(false);

    const onReEnrolClick = (alumniStudent) => {
        if (alumniStudent?.hasOverdueInvoices) {
            setOpenOverdueInvoicesModal(true);
        } else {
            navigate(`/alumni/${alumniStudent.studentId}`);
        }
    };

    useEffect(() => {
        onChangeActiveStudentId();
    }, []);

    return (
        <div className="page-content alumni-page">
            <div className="student-head-section--inner">
                <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                        <Breadcrumbs
                            breadcrumbs={[
                                { label: t("navigation.home"), href: "/" },
                                { label: t("alumni.alumni"), current: true },
                            ]}
                        />
                        <Typography variant="h1" className="text-white">
                            {t("alumni.title")}
                        </Typography>
                        <Typography variant="body1" className="mt-4 text-white" component="div">
                            {t("alumni.subtitle1")}
                            <ul>
                                <li>{t("alumni.subtitlePoint1")}</li>
                                <li>{t("alumni.subtitlePoint2")}</li>
                                <li>{t("alumni.subtitlePoint3")}</li>
                                <li>{t("alumni.subtitlePoint4")}</li>
                            </ul>
                            {t("alumni.subtitle2")}
                            <a href="https://kingsinterhigh.co.uk/contact" target="_blank" className="text-white" rel="noreferrer">
                                {t("alumni.subtitleAction")}
                            </a>
                        </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                        <TaskCard
                            title={t("alumni.reJoiningTitle")}
                            className="alumni__task-card"
                            isPrimary
                        >
                            <Typography variant="body1" component="div">
                                {t("alumni.reJoiningSubtitle")}
                            </Typography>
                        </TaskCard>
                    </Grid2>
                </Grid2>
            </div>
            <div className="relative z-1">
                <Typography variant="h2" component="h2" className="text-white">
                    {t("alumni.yourFormerStudents")}
                </Typography>
                {alumni.map((alumniStudent) => (
                    <div className="student-box mt-4" key={alumniStudent.studentId}>
                        <div className="student-box__main">
                            <div className="student-box__avatar">
                                {`${alumniStudent.forename?.[0]}${alumniStudent.surname?.[0]}`}
                            </div>
                            <span className="student-box__title">
                                {alumniStudent.fullName}
                            </span>
                        </div>
                        <span className="student-box__tag">
                            {t("alumni.alumni")}
                        </span>
                        <Button
                            onClick={() => onReEnrolClick(alumniStudent)}
                            className="student-box__button button-accent"
                        >
                            {t("alumni.reEnrolStudent")}
                        </Button>
                    </div>
                ))}
                <div className="details-box mt-8">
                    <Typography variant="h4" component="div" className="w-full text-primary">
                        {t("alumni.needHelp")}
                    </Typography>
                    <Typography variant="body1" component="div">
                        {t("alumni.needHelpContact")}
                        <a href={`mailto:${t("alumni.needHelpEmail")}`} className="text-primary">
                            {t("alumni.needHelpEmail")}
                        </a>
                    </Typography>
                </div>
            </div>
            <BaseDialog
                open={openOverdueInvoicesModal}
                onClose={() => setOpenOverdueInvoicesModal(false)}
                title={t("alumni.overdueInvoicesModal.title")}
                className="p-4"
                isWide
            >
                <Typography variant="body2" component="div">
                    {t("alumni.overdueInvoicesModal.text")}
                </Typography>
                <Typography variant="h5" component="div" className="text-primary mt-4">
                    {t("alumni.overdueInvoicesModal.contactFinance")}
                    <a
                        className="text-primary"
                        href={`mailto:${t("alumni.overdueInvoicesModal.email")}`}
                    >
                        {t("alumni.overdueInvoicesModal.email")}
                    </a>
                </Typography>
            </BaseDialog>
        </div>
    );
};

export default Alumni;
